import { CROP_ATTRIBUTE_TYPES } from "./crop_attribute_type"

export default {
  methods: {
    qualityAttributeIsBoolean: function (quality_attribute) {
      return quality_attribute.crop_attribute_type_id == CROP_ATTRIBUTE_TYPES.boolean.id;
    },
    qualityAttributeIsContinous: function (quality_attribute) {
      return quality_attribute.crop_attribute_type_id == CROP_ATTRIBUTE_TYPES.continous.id;
    },
    qualityAttributeHasFloatValue: function (quality_attribute) {
      return this.qualityAttributeIsBoolean(quality_attribute) ||
             this.qualityAttributeIsContinous(quality_attribute);
    },
  },
}
